<template>
<div>
  <tab></tab>
</div>
</template>

<script>
import { Tab } from '../components/'

export default {
  ready () {
  },
  components: {
    Tab
  },
  data () {
    return {}
  }
}
</script>



/** WEBPACK FOOTER **
 ** Tab.vue?59160fa0
 **/